import { TableFiltersState } from 'types/common';

export const getFilterParams = ({ from, to, status }: TableFiltersState) => ({
    from,
    to,
    status,
});
